import { ZoomOut, ZoomIn } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../atoms/Tooltip';

export const Zoom = ({ handleZoomOut, handleZoomIn }: { handleZoomOut: () => void; handleZoomIn: () => void }) => {
  return (
    <div
      className="group z-30 flex items-center space-x-1 rounded-lg border-2 border-blue-300 bg-blue-50 px-1.5 py-1 shadow-xl transition-all hover:border-blue-400 hover:bg-blue-100"
      style={{ alignSelf: 'flex-start' }}
    >
      <TooltipProvider delayDuration={0} skipDelayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={handleZoomOut}
              aria-label="Zoom out"
              className="h-4 w-4 cursor-pointer text-blue-600 transition-transform group-hover:scale-110 group-hover:text-blue-800"
            >
              <ZoomOut className="h-4 w-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Zoom out</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <div className="h-4 w-px bg-gray-300" />
      <TooltipProvider delayDuration={0} skipDelayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={handleZoomIn}
              aria-label="Zoom in"
              className="h-4 w-4 cursor-pointer text-blue-600 transition-transform group-hover:scale-110 group-hover:text-blue-800"
            >
              <ZoomIn className="h-4 w-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Zoom in</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
